<template>
    <div class="protocal-box">
        <MenuList 
            :son_id="state.son_id" 
            :fater_id="state.fater_id"
            @getDetail="getDetail" />
        <div class="protocal-content">
            <div class="tab_box">
                <div
                    class="tab_item"
                    :class="{ active: state.public_status === tabItem.id }"
                    v-for="(tabItem, index) in state.tabList"
                    :key="index"
                    @click="handleTabChange(tabItem.id)"
                >
                    {{ tabItem.title }}
                </div>
            </div>
            <div v-for="(item, index) in state.list" :key="index" class="rule_column">
                <div class="protocal-content-title">
                    <strong class="title_text">{{ item.title }}</strong>
                    <a
                        href="javascript:void(0)"
                        class="view_link"
                        @click.prevent="handleView(item.id)"
                    >
                        点击查看
                    </a>
                </div>
                <div class="public_time">公示时间：{{ formatPublicTime(item.public_time) }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import MenuList from "@@/protocal/menu.vue"

import { getRulePublicityList } from "@/api/index"
import { reactive, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router";

const state = reactive({
    public_status: 0, // 0: 公示中, 1: 已公示
    list: [],
    tabList: [
        {
            title: '公示中',
            id: 0
        },
        {
            title: '已公示',
            id: 1
        }
    ]
})

const route = useRoute();
const router = useRouter();
onMounted(() => {
    state.son_id = route.params.son_id
    state.fater_id = route.params.fater_id
    getList()
})

const getList = () => {
    getRulePublicityList({
        public_status: state.public_status
    }).then(res => {
        state.list = res.data
    })
}

const handleTabChange = (id) => {
    if (state.public_status === id) return
    state.public_status = id
    getList()
}

const handleView = (id) => {
    if (!id) return
    router.push({
        name: "protocalRuleDetail",
        params: {
            rule_id: id
        }
    })
}

const formatPublicTime = (value) => {
    if (!value) return ""
    if (typeof value !== "string") return value

    const isoPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/
    if (!isoPattern.test(value)) return value

    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return value

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
}

</script>

<style lang="scss" scoped>
.protocal-box {
    width: 1080px;
    margin: 40px auto;
    display: flex;
    .protocal-content {
        width: 0;
        flex: 1;
        line-height: 24px;
        font-size: 16px;
        .tab_box {
            display: flex;
            align-items: center;
            gap: 56px;
            border-bottom: 1px solid #e8e8e8;
            .tab_item {
                position: relative;
                padding: 0 2px 12px;
                font-size: 20px;
                line-height: 48px;
                font-weight: 500;
                color: #333333;
                cursor: pointer;
                &.active::after {
                    content: "";
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    height: 3px;
                    background: #333333;
                }
            }
        }
        .rule_column {
            padding: 24px 0;
            border-bottom: 1px solid #e8e8e8;
            .public_time {
                color: #666666;
                font-size: 16px;
                line-height: 24px;
            }
        }
        &-title {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 12px;
            .title_text {
                font-size: 16px;
                line-height: 24px;
                color: #333333;
                font-weight: 600;
            }
            .view_link {
                color: #1677ff;
                font-size: 16px;
                line-height: 24px;
                text-decoration: underline;
                cursor: pointer;
            }
        }
    }
    // .protocal-content-content {
    //     .p-padding span {
    //         font-family: PingFang SC-Regular, PingFang SC;
    //         font-size: 16px !important;
    //     }
    // }

}
</style>
